<template>
    <!-- 生活消费 1  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[7, 5]" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'life-one',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0--36.png",
            rightBg: "/img/pay/0--68.png",
        }
    },
    computed: {
        title() {
            return this.$t('life.title');
        },
        subtitle() {
            return this.$t('lifeOne.subtitle');
        },
        description() {
            const desc = this.$t('lifeOne.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>